/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataAdditionalServiceGroupInfoRespVo } from './PageDataAdditionalServiceGroupInfoRespVo';
import {
    PageDataAdditionalServiceGroupInfoRespVoFromJSON,
    PageDataAdditionalServiceGroupInfoRespVoFromJSONTyped,
    PageDataAdditionalServiceGroupInfoRespVoToJSON,
    PageDataAdditionalServiceGroupInfoRespVoToJSONTyped,
} from './PageDataAdditionalServiceGroupInfoRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataAdditionalServiceGroupInfoRespVo
 */
export interface ResponsePageDataAdditionalServiceGroupInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataAdditionalServiceGroupInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataAdditionalServiceGroupInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataAdditionalServiceGroupInfoRespVo}
     * @memberof ResponsePageDataAdditionalServiceGroupInfoRespVo
     */
    data?: PageDataAdditionalServiceGroupInfoRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataAdditionalServiceGroupInfoRespVo interface.
 */
export function instanceOfResponsePageDataAdditionalServiceGroupInfoRespVo(value: object): value is ResponsePageDataAdditionalServiceGroupInfoRespVo {
    return true;
}

export function ResponsePageDataAdditionalServiceGroupInfoRespVoFromJSON(json: any): ResponsePageDataAdditionalServiceGroupInfoRespVo {
    return ResponsePageDataAdditionalServiceGroupInfoRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataAdditionalServiceGroupInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataAdditionalServiceGroupInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataAdditionalServiceGroupInfoRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataAdditionalServiceGroupInfoRespVoToJSON(json: any): ResponsePageDataAdditionalServiceGroupInfoRespVo {
    return ResponsePageDataAdditionalServiceGroupInfoRespVoToJSONTyped(json, false);
}

export function ResponsePageDataAdditionalServiceGroupInfoRespVoToJSONTyped(value?: ResponsePageDataAdditionalServiceGroupInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataAdditionalServiceGroupInfoRespVoToJSON(value['data']),
    };
}

